import React from 'react';
import {
  Box,
  Flex, NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper, Slider, SliderFilledTrack, SliderThumb, SliderTrack,
  Text
} from "@chakra-ui/react";
import {LANGUAGE_CONFIGURATION_BOUNDS} from "../../models/constants/constants.ts";
import {ILanguageConfiguration} from "../../models/interfaces/languageConfiguration.interface.ts";

interface languageConfigurationProps {
  config: Partial<ILanguageConfiguration>;
  setConfig: (config: Partial<ILanguageConfiguration>) => void;
  isDisabled?: boolean

}


const labels: Record<string, string> = {
  maxCharactersPerLine: "Max Characters per line",
  minFramesGap: "Min frame gap",
  maxSubtitleTime: "Max duration in seconds",
  maxLines: "Max lines",
  minSubtitleTimeInFrames: "Min duration in frames",
};

const LanguageConfiguration: React.FC<languageConfigurationProps> = (
  {
    config,
    setConfig,
    isDisabled
  }) => {
  return (
    <Flex flexDir="column" gap={1}>
      {Object.entries(config).map(([key, val]) => {
        const typedKey = key as keyof ILanguageConfiguration;
        return (
          <Box key={key} mb={2}>
            <Text color="white" fontSize="sm" mb={1}>
              {labels[key]}
            </Text>
            <Flex className="items-center">
              <NumberInput
                min={LANGUAGE_CONFIGURATION_BOUNDS[typedKey].min}
                max={LANGUAGE_CONFIGURATION_BOUNDS[typedKey].max}
                maxW="180px"
                mr="2rem"
                value={val}
                onChange={(e: string) => setConfig({[key]: Number(e)})}
                isDisabled={isDisabled}
              >
                <NumberInputField
                  sx={{
                    border: "none",
                    outline: "none",
                    boxShadow: "0 0 0 0.5px gray",
                    color: "white",
                    _focus: {
                      boxShadow: "0 0 0 1px brandPurple.500",
                    },
                    _hover: {
                      boxShadow: "0 0 0 1px brandPurple.500",
                    },
                  }}
                />
                <NumberInputStepper>
                  <NumberIncrementStepper color="white"/>
                  <NumberDecrementStepper color="white"/>
                </NumberInputStepper>
              </NumberInput>
              <Box flex="1" pr="24px">
                <Slider
                  min={LANGUAGE_CONFIGURATION_BOUNDS[typedKey].min}
                  max={LANGUAGE_CONFIGURATION_BOUNDS[typedKey].max}
                  focusThumbOnChange={false}
                  value={val}
                  onChange={(e: number) => setConfig({[key]: Number(e)})}
                  isDisabled={isDisabled}
                >
                  <SliderTrack bg="white">
                    <SliderFilledTrack bg="brandPurple.500"/>
                  </SliderTrack>
                  <SliderThumb
                    fontSize="sm"
                    boxSize="32px"
                    bg="white"
                    color="black"
                    border="2px solid brandPurple.500"
                  >
                    {val}
                  </SliderThumb>
                </Slider>
              </Box>
            </Flex>
          </Box>
        );
      })}
    </Flex>
  )
}

export default LanguageConfiguration;